import axios from "axios";
import { ToastWarning } from "../../Shared/Toasts/ToastWarning";
import {
  findSoucheOrderApi,
  findSoucheOrderOnlineApi,
} from "../Redux/Slices/Orders/OrderSlice";
import { OrderType } from "../Types/Entites/Orders/OrderType";
import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import iconv from "iconv-lite"; // npm i iconv-lite

export const calculTTc = (prixht: any, tva: number) => {
  return parseFloat(prixht) + (parseFloat(prixht) * tva) / 100;
};

export const calculHt = (prixttc: number, tva: number) => {
  return (100 * prixttc) / (100 + tva);
};

export const calculTTC_Remise = (
  prix_ttc: number,
  quantite: number,
  remise: number,
) => {
  const totalBeforeRemise = quantite * prix_ttc;
  const remiseAmount = (totalBeforeRemise * remise) / 100;
  const totalAfterRemise = totalBeforeRemise - remiseAmount;

  const round = (value: number, decimalPlaces: number): number => {
    const factor = 10 ** decimalPlaces;
    return Math.round(value * factor) / factor;
  };

  return round(totalAfterRemise, 3);
};

export const formadate = (date: any) => {
  if (date) {
    const inputDate = new Date(date);

    const day = inputDate.getDate().toString().padStart(2, "0");
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
    const year = inputDate.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  } else {
    return "";
  }
};
export const formatDate = (date: any) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatdate = (date: any) => {
  const inputDate = new Date(date);

  const day = inputDate.getDate().toString().padStart(2, "0");
  const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
  const year = inputDate.getFullYear();

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};
export const generateRandomEAN = (length: any) => {
  const randomDigits = Array.from({ length }, () =>
    Math.floor(Math.random() * 10),
  ).join("");
  return calculateEANCheckDigit(randomDigits, length);
};

const calculateEANCheckDigit = (digits: any, length: any) => {
  if (digits.length !== length) {
    throw new Error(`Invalid number of digits for EAN-${length}`);
  }

  let sum = 0;
  for (let i = 0; i < digits.length; i++) {
    const digit = parseInt(digits[i], 10);
    sum += i % 2 === 0 ? digit : digit * 3;
  }

  const checkDigit = (10 - (sum % 10)) % 10;

  return `${digits}${checkDigit}`;
};
export const areArraysEqual = (arr1: any, arr2: any) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }

  return true;
};
export const handleKeyPress = (
  event: React.KeyboardEvent<HTMLInputElement>,
) => {
  const charCode = event.which || event.keyCode;

  // Allow only numeric characters (0-9), period (.), and minus sign (-)
  if ((charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
    event.preventDefault();
  }

  // Ensure that only one period is allowed
  const inputText = event.currentTarget.value;
  if (charCode === 46 && inputText.indexOf(".") !== -1) {
    event.preventDefault();
  }

  // Ensure that only one minus sign is allowed at the beginning
  if (charCode === 45 && inputText.indexOf("-") !== -1) {
    event.preventDefault();
  }
};
export const handleKeyPressCart = (
  event: React.KeyboardEvent<HTMLInputElement>,
) => {
  const charCode = event.which || event.keyCode;

  // Allow only numeric characters (0-9), period (.), and minus sign (-)
  if ((charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
    event.preventDefault();
  }

  // Ensure that only one period is allowed
  const inputText = event.currentTarget.value;
  if (charCode === 46 && inputText.indexOf(".") !== -1) {
    event.preventDefault();
  }

  // Ensure that only one minus sign is allowed at the beginning
  if (charCode === 45 && inputText.indexOf("-") !== -1) {
    event.preventDefault();
  }
};
export const formatDateAndTime = (timestamp: any) => {
  if (timestamp) {
    const dateObject = new Date(timestamp);

    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");

    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    const seconds = dateObject.getSeconds().toString().padStart(2, "0");

    const formattedDateAndTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateAndTime;
  } else {
    return "-";
  }
};

export const Dateformat = (timestamp: Date) => {
  if (timestamp) {
    const dateObject = new Date(timestamp);

    const year = dateObject.getFullYear();
    const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
    const day = dateObject.getDate().toString().padStart(2, "0");

    const formattedDate = `${year}-${month}-${day} `;

    return formattedDate;
  } else {
    return "-";
  }
};

export const Timeformat = (timestamp: Date) => {
  if (timestamp) {
    const dateObject = new Date(timestamp);

    const hours = dateObject.getHours().toString().padStart(2, "0");
    const minutes = dateObject.getMinutes().toString().padStart(2, "0");
    const seconds = dateObject.getSeconds().toString().padStart(2, "0");

    const formattedTime = ` ${hours}:${minutes}:${seconds}`;

    return formattedTime;
  } else {
    return "-";
  }
};

export const handleKeyPress_number = (
  event: React.KeyboardEvent<HTMLInputElement>,
) => {
  const charCode = event.which || event.keyCode;

  // Allow only numeric characters (0-9), period (.), and minus sign (-)
  if ((charCode < 48 || charCode > 57) && charCode !== 46) {
    event.preventDefault();
  }

  // Ensure that only one period is allowed
  const inputText = event.currentTarget.value;
  if (charCode === 46 && inputText.indexOf(".") !== -1) {
    event.preventDefault();
  }
};
export const formatTime = ({ date }: { date: string }) => {
  const options: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  return new Date(date).toLocaleTimeString(undefined, options);
};
export const ajouterDureeToDate = (dateString: any, dureeEnJours: any) => {
  var date = new Date(dateString);
  date.setDate(date.getDate() + dureeEnJours);
  return date.toISOString();
};

export const calculateDiscountedPrice = (
  originalPrice: number,
  discountPercentage: number,
) => {
  let discountAmount = (originalPrice * discountPercentage) / 100;
  let discountedPrice = originalPrice - discountAmount;
  return discountedPrice;
};

export const calculateRemise = (item: any) => {
  let montantRemiseArticle = 0;
  let montantRemiseClient = 0;
  let totalRemise = 0;

  const finalQte = item.quantity;
  let netRemise = finalQte * item.prix_unitaire;

  if (item.remise > 0) {
    montantRemiseArticle = (finalQte * item.prix_unitaire * item.remise) / 100;
    netRemise -= montantRemiseArticle; // Apply article discount
  }

  if (item.remiseClient > 0) {
    montantRemiseClient = (netRemise * item.remiseClient) / 100;
  }

  totalRemise = montantRemiseArticle + montantRemiseClient;
  return { totalRemise, montantRemiseArticle, montantRemiseClient };
};

export const maxRemise = (list: any) => {
  const maxRemise = list?.reduce((max: any, remise: any) => {
    return remise?.percentage > max?.percentage ? remise : max;
  }, list[0]);

  return maxRemise?.percentage;
};

export const LastCreatedRemise = (list: any) => {
    console.log('lastRemiselastlist',list)

  if (!list || list.length === 0) return null;
  const lastRemise = list.reduce((latest:any, current:any) => {
    const latestTime = new Date(latest?.createdAt).getTime();
    const currentTime = new Date(current?.createdAt).getTime();

    // If current is newer than latest, return current
    return currentTime > latestTime ? current : latest;
  }, list[0]);
 
  console.log('lastRemiselastRemise',lastRemise)
  return lastRemise?.percentage;
};
export const sumGratuiteQuantity = (list: any) => {
  if (Array.isArray(list)) {
    const sum = list.reduce(
      (accumulator: any, currentValue: any) =>
        accumulator + currentValue.quantity,
      0,
    );
    return sum;
  }
};

export const formatFloat = (number: any) => {
  if (number) {
    if (typeof number === "string") {
      number = parseFloat(number);
    }

    let formattedNumber = number.toString();
    if (formattedNumber.indexOf(".") !== -1) {
      formattedNumber = parseFloat(number).toFixed(3);
    } else {
      formattedNumber += ".000";
    }

    return formattedNumber;
  }
};

export const generateOrderNumber = (orders: OrderType[]) => {
  let uniqueId: string;
  const existingOrderNumbers = orders?.map((order) => order.order_number);
  do {
    uniqueId = "#" + (Math.floor(Math.random() * 90000) + 10000).toString();
  } while (
    existingOrderNumbers?.some((orderNumber) => orderNumber === uniqueId)
  );
  return uniqueId;
};

export const generateUniqueCode = (list: any[]) => {
  let uniqueId: string;
  const existingItems = list.map((item) => item.code);
  do {
    uniqueId = (Math.floor(Math.random() * 90000) + 10000).toString();
  } while (existingItems.some((code) => code === uniqueId));
  return uniqueId;
};
export const exportExcel = (
  namefile: string,
  nomcfeuille: string,
  list: any[],
) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(list);

  XLSX.utils.book_append_sheet(wb, ws, nomcfeuille);
  XLSX.writeFile(wb, namefile);
};

export const exportExcelNoHeader = (
  namefile: string,
  nomcfeuille: string,
  list: any[],
) => {
  const wb = XLSX.utils.book_new();
  const dataFormatted = formatMontants(list, true);

  const ws = XLSX.utils.aoa_to_sheet(dataFormatted);

  XLSX.utils.book_append_sheet(wb, ws, nomcfeuille);
  XLSX.writeFile(wb, namefile);
};

const formatMontants = (list: any[], useCommaDecimal: boolean) => {
  return list.map((row) =>
    Object.values(row).map((value) => {
      if (typeof value === "number") {
        // Convertir nombre en string avec point ou virgule
        return useCommaDecimal
          ? value.toFixed(2).replace(".", ",") // ex: 1234.56 -> "1234,56"
          : value.toFixed(2); // ex: 1234.56 -> "1234.56"
      }
      return value;
    }),
  );
};

export const numberToWords = (amount: number): string => {
  const ones: string[] = [
    "",
    "Un",
    "Deux",
    "Trois",
    "Quatre",
    "Cinq",
    "Six",
    "Sept",
    "Huit",
    "Neuf",
    "Dix",
    "Onze",
    "Douze",
    "Treize",
    "Quatorze",
    "Quinze",
    "Seize",
    "Dix-sept",
    "Dix-huit",
    "Dix-neuf",
  ];

  const tens: string[] = [
    "",
    "",
    "Vingt",
    "Trente",
    "Quarante",
    "Cinquante",
    "Soixante",
    "Soixante-dix",
    "Quatre-vingts",
    "Quatre-vingt-dix",
  ];

  const thousands: string[] = ["", "Mille", "Million", "Milliard", "Billion"];

  function convert(num: number): string {
    if (num === 0) return "";

    if (num < 20) return ones[num];

    if (num < 100)
      return (
        tens[Math.floor(num / 10)] +
        (num % 10 !== 0 ? " " + ones[num % 10] : "")
      );

    if (num < 1000)
      return (
        (num === 100 ? "Cent" : ones[Math.floor(num / 100)] + " Cent") +
        (num % 100 !== 0 ? " " + convert(num % 100) : "")
      );

    let index = 0;
    let result = "";

    while (num > 0) {
      if (num % 1000 !== 0) {
        result =
          convert(num % 1000) +
          " " +
          thousands[index] +
          (result ? " " + result : "");
      }
      num = Math.floor(num / 1000);
      index++;
    }

    return result.trim();
  }

  // Split the amount into dinars and millimes
  const [integerPart, decimalPart] = amount.toString().split(".");

  // Convert the dinars part
  let result = convert(Number(integerPart)) + " dinars";

  // Convert the millimes part (if exists and is not zero)
  if (decimalPart) {
    const millimes = decimalPart.padEnd(3, "0").slice(0, 3); // Ensure millimes are 3 digits
    if (millimes !== "000") {
      const millimesInWords = convert(Number(millimes));
      result += " et " + millimesInWords + " millimes";
    }
  }

  // Handle the case of exactly zero millimes (no "et millimes" part)
  if (decimalPart === undefined || decimalPart === "000") {
    result += " et zéro millimes";
  }

  return result.trim();
};

export const NextOrderStatus = (status: any) => {
  switch (status) {
    case "En cours":
      return "En livraison"; // No need for break because the function returns here.

    case "En livraison":
      return "Retour"; // Similarly, return ends execution here.

    default:
      return "Status inconnu"; // Optionally handle the default case if no match is found
  }
};
export const statusList = [
  { status: "Tout", label: "Tout" },
  { status: "Payée", label: "Payée" },
  { status: "Pre-confirmée", label: "Pre-confirmée" },
  { status: "En livraison", label: "En livraison" },
  { status: "En attente", label: "En attente" },
  { status: "Nouvelle", label: "Nouvelle" },
];
export const findSoucheCommande = async (
  organisation_id: any,
  type: string,
  dispatch: any,
) => {
  if (organisation_id) {
    const respsouche = await dispatch(findSoucheOrderApi(organisation_id));
    return respsouche.payload;
  }
};
export const findSoucheCommandeOnline = async (
  organisation_id: any,
  dispatch: any,
) => {
  if (organisation_id) {
    const respsouche = await dispatch(
      findSoucheOrderOnlineApi(organisation_id),
    );
    return respsouche.payload;
  }
};
export const getLongLine = (text: any, maxLength: any) => {
  if (text) {
    const lines = text.split("\n"); // Diviser le texte en lignes
    for (const line of lines) {
      if (line.length > maxLength) {
        return line; // Retourne la première ligne trop longue
      }
    }
  }

  return null; // Aucune ligne ne dépasse la limite
};
export function compareDates(datefin: any, datedebut: any) {
  // Convertir les dates en objets Date si elles sont en format chaîne
  const dfin = new Date(datefin);
  const ddebut = new Date(datedebut);

  // Vérifier si date1 < date2
  if (dfin < ddebut) {
    ToastWarning(
      "La date de fin ne peut pas être antérieure à la date de début.",
    );
  }
}
export function isExpired(date: any, period: any) {
  const retourDate = new Date(date); // Convert string to Date
  retourDate.setDate(retourDate.getDate() + period); // Add duree_retour days

  const today = new Date(); // Get today's date
  today.setHours(0, 0, 0, 0); // Normalize time to avoid issues

  return retourDate < today; // Check if expired
}

export const StockArticle = (data: any): number => {
  const totalStockPerOrg: Record<string, number> = {};
  const stockData = data.stock;

  for (const orgId in stockData) {
    totalStockPerOrg[orgId] = stockData[orgId].reduce(
      (sum: number, item: any) => sum + (item.stock || 0),
      0,
    );
  }

  const totalStock = Object.values(totalStockPerOrg).reduce(
    (sum: number, value: number) => sum + value,
    0,
  );

  return totalStock;
};
export const calculerTotalStock = (stockObj: any) => {
  const l = Object.values(stockObj.map((s: any) => s.stock).flat());
  const totalStock = l.reduce((total: any, item: any) => {
    return (
      total +
      Object.values(item) // tableaux par organisation
        .flat() // on met tout à plat
        .reduce((sum, stockItem: any) => sum + (stockItem.stock || 0), 0)
    );
  }, 0);

  return totalStock;
};
export const generateUniqueColor = (index: any) => {
  // Constantes pour la génération
  const goldenRatioConjugate = 0.618033988749895; // Nombre d'or
  const saturation = 60; // Saturation fixe pour des couleurs pastel
  const lightness = 85; // Luminosité élevée pour des teintes douces

  // Calculer la teinte (hue) basée sur l'index
  const hue = (index * goldenRatioConjugate * 360) % 360;

  // Retourner la couleur en format HSL
  return `hsl(${Math.round(hue)}, ${saturation}%, ${lightness}%)`;
};

export const StockOrganisation = (stock: any, orgId: any) => {
  let totalOrg = 0;
  stock?.forEach((ligne: any) => {
    totalOrg +=
      ligne.stock[orgId]?.reduce(
        (sum: any, item: any) => sum + item.stock,
        0,
      ) || 0;
  });
  return totalOrg;
};

export const StockOrganisationshow = (stock: any, orgId: any) => {
  let show = false;
  stock?.forEach((ligne: any) => {
    const findStock = ligne.stock[orgId]?.find((s: any) => s.stock > 0);

    if (findStock) {
      show = true;
    }
  });
  return show;
};
export const calculremisefromval = (oldPrix: number, newPrix: number) => {
  const remise = 100 - (newPrix * 100) / oldPrix;
  return remise?.toFixed(3);
};
export const calculPrixremise = (oldPrix: number, Pourcentage: number) => {
  const remise = oldPrix * ((100 - Pourcentage) / 100);
  return remise?.toFixed(3);
};

export const getCookieValue = (name: string): string | null => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

export const openDrawer = async () => {
  let setIsLoading = true;
  let setStatus = "Sending command...";

  try {
    // Call to our local API service
    await axios.post("adressMac/open-drawer");
    setStatus = "Drawer opened successfully!";
  } catch (error: any) {
    console.error("Error opening drawer:", error);
    setStatus = `Error: ${error.message}`;
  } finally {
    setIsLoading = false;
  }
};

/***************.Impression Ticket******** */
const encodeText = (lines: string[]) => {
  // Convertit tout le ticket en buffer ISO-8859-1
  return iconv.encode(lines.join("\n"), "ISO-8859-1");
};

const addBarcode = (orderNumber: string): Uint8Array => {
  const codeData = "{B" + orderNumber; // CODE128 subset B
  const bytes = [0x1d, 0x6b, 73, codeData.length]; // GS k 73 length
  for (let i = 0; i < codeData.length; i++) {
    bytes.push(codeData.charCodeAt(i));
  }
  // Certains modèles ESC/POS nécessitent un 0x00 final
  bytes.push(0x00);
  return new Uint8Array(bytes);
};

export const ImpressionTicket = (
  typeTicket: any,
  data: any,
  parametrage: any,
) => {
  console.log(typeTicket, data, parametrage);
  const orderItemsGroupedByTva = _.groupBy(
    data?.ticket?.ticket_order.items,
    "article.tva",
  );
  const fees =
    Number(data?.ticket?.ticket_order.timbre_facture) +
    Number(data?.ticket?.ticket_order.timbre);
  if (typeTicket === "Ticket Caisse") {
    if (parametrage && parametrage.ticketTemplate === "small") {
      console.log("t");
    } else {
      if (!data) return [];

      const lines: string[] = [];

      // --- HEADER ---
      lines.push("\x1B\x61\x01"); // centrer
      lines.push("\x1B\x45\x01"); // gras ON
      lines.push(`Ticket de caisse - ${data?.societe?.nom}`);
      lines.push(data?.organisation?.description || "");
      lines.push(`Tel: ${data?.societe.tel || ""}`);
      lines.push("\x1B\x45\x00"); // gras OFF

      lines.push("\x1B\x45\x00\x1B\x61\x00"); // gauche + gras OFF

      // --- INFOS COMMANDE ---
      lines.push(`Numero: ${data?.ticket.ticket_order.order_number}`);
      lines.push(`Caissier: ${data?.user.nom} ${data?.user.prenom}`);
      if (data?.vendeur)
        lines.push(`Vendeur: ${data?.vendeur.nom} ${data?.vendeur.prenom}`);

      lines.push("-".repeat(32));

      // --- DATE / HEURE ---
      lines.push(
        `Date: ${formatDate(new Date())} - Heure: ${formatTime({
          date: new Date().toISOString(),
        })}`,
      );

      lines.push("-".repeat(32));

      // --- ITEMS ---
      data?.ticket.ticket_order.items.forEach((item: any) => {
        if (item.quantity === 0) return;

        const name =
          item.article.titre.fr +
          (item.article.caracteristiques
            ? " " +
              item.article.caracteristiques
                .map((c: any) =>
                  typeof c.value === "string" ? c.value : c.value.libelle || "",
                )
                .join(", ")
            : "");

        const qty = item.quantity;
        const total = item.quantity < 0 ? item.prixNet : item.prix_total;

        lines.push(
          `${qty}x ${name}`.padEnd(24, " ") + total.toFixed(3).padStart(8, " "),
        );

        if (item.remise > 0 && item.remise !== 100)
          lines.push(
            `  Remise: ${item.remise}${
              data?.ticket.ticket_order.typeRemise === "pourcentage"
                ? "%"
                : "TND"
            }`,
          );
        if (item.remiseClient > 0)
          lines.push(`  Remise client: ${item.remiseClient}%`);
      });

      lines.push("-".repeat(32));

      // --- REDUCTIONS / TOTAL ---
      const totalAfterFees = data?.ticket.ticket_order.total - fees;
      lines.push(`Total: ${totalAfterFees.toFixed(3)}`);
      if (data?.ticket.ticket_order.timbre)
        lines.push(
          `Timbre ticket: ${data?.ticket.ticket_order.timbre.toFixed(3)}`,
        );
      if (data?.ticket.ticket_order.timbre_facture)
        lines.push(
          `Timbre Facture: ${data?.ticket.ticket_order.timbre_facture.toFixed(
            3,
          )}`,
        );
      lines.push(`Total Net: ${data?.ticket.ticket_order.totalNet.toFixed(3)}`);
      lines.push("-".repeat(32));
      // --- FIDELITE ---
      if (data?.pointsfidelite) {
        lines.push(`Points fidelite: ${data?.pointsfidelite}`);
      }
      if (data?.pointsClient) {
        lines.push(`Points client: ${data?.pointsClient}`);
      }
      // --- PAIEMENTS ---
      if (Array.isArray(data.paymentList) && data.paymentList.length > 0) {
        lines.push("Reglement(s):");

        data.paymentList.forEach((payment: any) => {
          lines.push(
            `  ${payment.payment_method}: ${payment.amount.toFixed(3)}`,
          );
          if (payment.payment_method === "Espéces" && payment.rendu) {
            lines.push(`  Rendu: ${payment.rendu.toFixed(3)}`);
          }
        });
      }

      // --- TVA ---
      Object.entries(orderItemsGroupedByTva).forEach(([taux, items]: any) => {
        const baseHT = items
          .reduce(
            (acc: any, val: any) =>
              acc +
              val.article.prix_vente_ht * val.quantity -
              val.article.prix_vente_ht * val.quantity * (val.remise / 100) -
              val.article.prix_vente_ht *
                val.quantity *
                (val.remiseClient / 100),
            0,
          )
          .toFixed(3);
        const montantTVA = (
          (items.reduce(
            (acc: any, val: any) =>
              acc + val.article.prix_vente_ht * val.quantity,
            0,
          ) *
            Number(taux)) /
          100
        ).toFixed(3);

        lines.push(
          `TVA ${taux || 0}% - Base HT: ${baseHT} - Montant: ${montantTVA}`,
        );
      });
      if (data.ticket.ticket_order.order_number) {
        lines.push("\x1B\x61\x01"); // ESC a 1 → center

        const barcodeBuffer = addBarcode(data.ticket.ticket_order.order_number);
        // Insérer le buffer à la fin
        lines.push(barcodeBuffer as any); // On traitera en buffer final
        lines.push("\x1B\x61\x01"); // ESC a 1 → center

        // Afficher le numéro de commande sous le code-barres
        lines.push(
          "\x1B\x45\x01" +
            data.ticket.ticket_order.order_number +
            "\x1B\x45\x00",
        );
      }

      // --- FOOTER ---

      // --- FOOTER / MESSAGE PROMO ---
      if (parametrage?.message_promo) {
        // Center alignment
        lines.push("\x1B\x61\x01"); // ESC a 1 → center

        // Split the message into lines and add ESC/POS line feed
        parametrage.message_promo.split("\n").forEach((line: string) => {
          // Each line ends with \x0A (LF) for proper line feed
          lines.push(line);
        });

        // Return to left alignment
        lines.push("\x1B\x61\x00"); // ESC a 0 → left
      }

      // Add some spacing before cut
      lines.push("\x0A\x0A"); // 2 line feeds

      // Cut the paper
      lines.push("\n\n\x1D\x56\x00"); // cut

      return lines;
    }
  } else if (typeTicket === "Avance") {
    if (!data) return [];

    const lines: string[] = [];

    // --- HEADER ---
    lines.push("\x1B\x61\x01"); // centrer
    lines.push("\x1B\x45\x01"); // gras ON
    lines.push(`Ticket de caisse - ${data?.societe?.nom}`);
    lines.push(data?.organisation?.description || "");
    lines.push(`Tel: ${data?.societe.tel || ""}`);
    lines.push("\x1B\x45\x00"); // gras OFF

    lines.push("\x1B\x45\x00\x1B\x61\x00"); // gauche + gras OFF

    // --- INFOS COMMANDE ---
    lines.push(`Numero: ${data?.ticket.ticket_order.order_number}`);
    lines.push(`Caissier: ${data?.user.nom} ${data?.user.prenom}`);
    if (data?.vendeur)
      lines.push(`Vendeur: ${data?.vendeur.nom} ${data?.vendeur.prenom}`);

    lines.push("-".repeat(32));

    // --- DATE / HEURE ---
    lines.push(
      `Date: ${formatDate(new Date())} - Heure: ${formatTime({
        date: new Date().toISOString(),
      })}`,
    );

    lines.push("-".repeat(32));
    //---- CLIENT
    lines.push(`Client(e): ${data?.Reservation?.infoclient?.nom}`);
    lines.push(`Num Client(e): ${data?.Reservation?.infoclient?.mobile}`);

    lines.push("-".repeat(32));
    // --- ITEMS ---
    data?.ticket.ticket_order.items.forEach((item: any) => {
      if (item.quantity === 0) return;

      const name =
        item.article.titre.fr +
        (item.article.caracteristiques
          ? " " +
            item.article.caracteristiques
              .map((c: any) =>
                typeof c.value === "string" ? c.value : c.value.libelle || "",
              )
              .join(", ")
          : "");

      const qty = item.quantity;
      const total = item.quantity < 0 ? item.prixNet : item.prix_total;

      lines.push(
        `${qty}x ${name}`.padEnd(24, " ") + total.toFixed(3).padStart(8, " "),
      );

      if (item.remise > 0 && item.remise !== 100)
        lines.push(
          `  Remise: ${item.remise}${
            data?.ticket.ticket_order.typeRemise === "pourcentage" ? "%" : "TND"
          }`,
        );
      if (item.remiseClient > 0)
        lines.push(`  Remise client: ${item.remiseClient}%`);
    });

    lines.push("-".repeat(32));

    lines.push(`Total: ${data?.Reservation?.achat_totalNet.toFixed(3)}`);
    // --- REDUCTIONS / TOTAL ---
    const totalAfterFees = data?.ticket.ticket_order.total - fees;
    lines.push(`Total: ${totalAfterFees.toFixed(3)}`);
    if (data?.ticket.ticket_order.timbre)
      lines.push(
        `Timbre ticket: ${data?.ticket.ticket_order.timbre.toFixed(3)}`,
      );
    if (data?.ticket.ticket_order.timbre_facture)
      lines.push(
        `Timbre Facture: ${data?.ticket.ticket_order.timbre_facture.toFixed(
          3,
        )}`,
      );
    lines.push(`Total Net: ${data?.ticket.ticket_order.totalNet.toFixed(3)}`);
    lines.push("-".repeat(32));
    lines.push(
      `  ${
        data?.ticket?.type === "Avance" ? "Avance" : "Montant payé"
      }: ${Number(data?.ticket?.ticket_order?.totalNet)?.toFixed(3)}`,
    );
    lines.push("-".repeat(32));

    // --- PAIEMENTS ---
    if (Array.isArray(data.paymentList) && data.paymentList.length > 0) {
      lines.push("Reglement(s):");

      data.paymentList.forEach((payment: any) => {
        lines.push(`  ${payment.payment_method}: ${payment.amount.toFixed(3)}`);
        if (payment.payment_method === "Espéces" && payment.rendu) {
          lines.push(`  Rendu: ${payment.rendu.toFixed(3)}`);
        }
      });
    }
    lines.push("-".repeat(32));
    lines.push(` Total avance: ${Number(data?.totalavance)?.toFixed(3)}`);
    const restpayer =
      Number(data?.Reservation?.achat_totalNet) -
      Number(
        data?.ticket.type === "Avance"
          ? data?.totalavance
          : data?.totalavance + data?.ticket?.ticket_order?.totalNet,
      );
    console.log("restpayer", data);

    console.log("restpayer1111111111", restpayer);
    if (restpayer > 0) {
      lines.push(` Reste a payer: ${restpayer.toFixed(3)}`);
    }

    // --- TVA ---
    Object.entries(orderItemsGroupedByTva).forEach(([taux, items]: any) => {
      const baseHT = items
        .reduce(
          (acc: any, val: any) =>
            acc +
            val.article.prix_vente_ht * val.quantity -
            val.article.prix_vente_ht * val.quantity * (val.remise / 100) -
            val.article.prix_vente_ht * val.quantity * (val.remiseClient / 100),
          0,
        )
        .toFixed(3);
      const montantTVA = (
        (items.reduce(
          (acc: any, val: any) =>
            acc + val.article.prix_vente_ht * val.quantity,
          0,
        ) *
          Number(taux)) /
        100
      ).toFixed(3);

      lines.push(
        `TVA ${taux || 0}% - Base HT: ${baseHT} - Montant: ${montantTVA}`,
      );
    });
    if (data.ticket.ticket_order.order_number) {
      lines.push("\x1B\x61\x01"); // ESC a 1 → center

      const barcodeBuffer = addBarcode(data.ticket.ticket_order.order_number);
      // Insérer le buffer à la fin
      lines.push(barcodeBuffer as any); // On traitera en buffer final
      lines.push("\x1B\x61\x01"); // ESC a 1 → center

      // Afficher le numéro de commande sous le code-barres
      lines.push(
        "\x1B\x45\x01" + data.ticket.ticket_order.order_number + "\x1B\x45\x00",
      );
    }

    // --- FOOTER ---

    // --- FOOTER / MESSAGE PROMO ---
    lines.push("\x1B\x61\x01"); // ESC a 1 → center
    lines.push(
      ` Date d'echeance : ${formatDate(
        new Date(data?.Reservation?.date_echeance),
      )}`,
    );

    if (parametrage?.message_promo) {
      // Center alignment
      lines.push("\x1B\x61\x01"); // ESC a 1 → center

      // Split the message into lines and add ESC/POS line feed
      parametrage.message_promo.split("\n").forEach((line: string) => {
        // Each line ends with \x0A (LF) for proper line feed
        lines.push(line);
      });

      // Return to left alignment
      lines.push("\x1B\x61\x00"); // ESC a 0 → left
    }

    // Add some spacing before cut
    lines.push("\x0A\x0A"); // 2 line feeds

    // Cut the paper
    lines.push("\n\n\x1D\x56\x00"); // cut

    return lines;
  } else if (typeTicket === "Ticket Paid") {
    if (parametrage && parametrage.ticketTemplate === "small") {
      console.log("t");
    } else {
      if (!data) return [];

      const lines: string[] = [];

      // --- HEADER ---
      lines.push("\x1B\x61\x01"); // centrer
      lines.push("\x1B\x45\x01"); // gras ON
      lines.push(`Ticket de caisse - ${data?.societe?.nom}`);
      lines.push(data?.organisation?.description || "");
      lines.push(`Tel: ${data?.societe.tel || ""}`);
      lines.push("\x1B\x45\x00"); // gras OFF

      lines.push("\x1B\x45\x00\x1B\x61\x00"); // gauche + gras OFF

      // --- INFOS COMMANDE ---
      lines.push(`Numero: ${data?.ticket.ticket_order.order_number}`);
      lines.push(`Caissier: ${data?.user.nom} ${data?.user.prenom}`);
      if (data?.vendeur)
        lines.push(`Vendeur: ${data?.vendeur.nom} ${data?.vendeur.prenom}`);

      lines.push("-".repeat(32));

      // --- DATE / HEURE ---
      lines.push(
        `Date: ${formatDate(new Date(data?.date))} - Heure: ${formatTime({
          date: data?.date,
        })}`,
      );
      lines.push("-".repeat(32));

      // --- ITEMS ---
      data?.ticket.ticket_order.items.forEach((item: any) => {
        if (item.quantity === 0) return;

        const name =
          item.article.titre.fr +
          (item.article.caracteristiques
            ? " " +
              item.article.caracteristiques
                .map((c: any) =>
                  typeof c.value === "string" ? c.value : c.value.libelle || "",
                )
                .join(", ")
            : "");

        const qty = item.quantity;
        const total = item.quantity < 0 ? item.prixNet : item.prix_total;

        lines.push(
          `${qty}x ${name}`.padEnd(24, " ") + total.toFixed(3).padStart(8, " "),
        );

        if (item.remise > 0 && item.remise !== 100)
          lines.push(
            `  Remise: ${item.remise}${
              data?.ticket.ticket_order.typeRemise === "pourcentage"
                ? "%"
                : "TND"
            }`,
          );
        if (item.remiseClient > 0)
          lines.push(`  Remise client: ${item.remiseClient}%`);
      });

      lines.push("-".repeat(32));

      // --- REDUCTIONS / TOTAL ---
      const totalAfterFees = data?.ticket.ticket_order.total - fees;
      lines.push(`Total: ${totalAfterFees.toFixed(3)}`);
      if (data?.ticket.ticket_order.timbre)
        lines.push(
          `Timbre ticket: ${data?.ticket.ticket_order.timbre.toFixed(3)}`,
        );
      if (data?.ticket.ticket_order.timbre_facture)
        lines.push(
          `Timbre Facture: ${data?.ticket.ticket_order.timbre_facture.toFixed(
            3,
          )}`,
        );
      lines.push(`Total Net: ${data?.ticket.ticket_order.totalNet.toFixed(3)}`);
      lines.push("-".repeat(32));

      // --- PAIEMENTS ---
      if (data.paymentList) {
        lines.push("Reglement(s):");

        Object.entries(data.paymentList).forEach(
          ([method, payments]: [string, any]) => {
            const totalAmount = payments.reduce(
              (sum: any, p: any) => sum + p.amount,
              0,
            );
            lines.push(`  ${method}: ${totalAmount.toFixed(3)}`);

            // Si l’un des paiements "Espèces" contient un rendu
            if (method === "Espéces") {
              payments.forEach((p: any) => {
                if (p.rendu) {
                  lines.push(`  Rendu: ${p.rendu.toFixed(3)}`);
                }
              });
            }
          },
        );
      }

      // --- TVA ---
      Object.entries(orderItemsGroupedByTva).forEach(([taux, items]: any) => {
        const baseHT = items
          .reduce(
            (acc: any, val: any) =>
              acc +
              val.article.prix_vente_ht * val.quantity -
              val.article.prix_vente_ht * val.quantity * (val.remise / 100) -
              val.article.prix_vente_ht *
                val.quantity *
                (val.remiseClient / 100),
            0,
          )
          .toFixed(3);
        const montantTVA = (
          (items.reduce(
            (acc: any, val: any) =>
              acc + val.article.prix_vente_ht * val.quantity,
            0,
          ) *
            Number(taux)) /
          100
        ).toFixed(3);

        lines.push(
          `TVA ${taux || 0}% - Base HT: ${baseHT} - Montant: ${montantTVA}`,
        );
      });
      if (data.ticket.ticket_order.order_number) {
        lines.push("\x1B\x61\x01"); // ESC a 1 → center

        const barcodeBuffer = addBarcode(data.ticket.ticket_order.order_number);
        // Insérer le buffer à la fin
        lines.push(barcodeBuffer as any); // On traitera en buffer final
        lines.push("\x1B\x61\x01"); // ESC a 1 → center

        // Afficher le numéro de commande sous le code-barres
        lines.push(
          "\x1B\x45\x01" +
            data.ticket.ticket_order.order_number +
            "\x1B\x45\x00",
        );
      }

      // --- FOOTER ---

      // --- FOOTER / MESSAGE PROMO ---
      if (parametrage?.message_promo) {
        // Center alignment
        lines.push("\x1B\x61\x01"); // ESC a 1 → center

        // Split the message into lines and add ESC/POS line feed
        parametrage.message_promo.split("\n").forEach((line: string) => {
          // Each line ends with \x0A (LF) for proper line feed
          lines.push(line);
        });

        // Return to left alignment
        lines.push("\x1B\x61\x00"); // ESC a 0 → left
      }

      // Add some spacing before cut
      lines.push("\x0A\x0A"); // 2 line feeds

      // Cut the paper
      lines.push("\n\n\x1D\x56\x00"); // cut

      return lines;
    }
  } else if (typeTicket === "Bon") {
    if (!data) return [];

    const lines: string[] = [];

    // --- HEADER ---
    lines.push("\x1B\x61\x01"); // centrer
    lines.push("\x1B\x45\x01"); // gras ON
    lines.push(` ${data?.societe?.nom}`);
    lines.push(` ${data?.bon?.type} ${data?.organisation.nom || ""}`);
    lines.push(`Tel: ${data?.societe.tel || ""}`);
    lines.push("\x1B\x45\x00"); // gras OFF

    lines.push("\x1B\x45\x00\x1B\x61\x00"); // gauche + gras OFF

    lines.push("-".repeat(32));

    // --- DATE / HEURE ---
    lines.push(
      `Date: ${formatDate(new Date(data?.bon.date))} - Heure: ${formatTime({
        date: data?.bon.date,
      })}`,
    );

    lines.push(
      `Expire le: ${
        data.bon && data.bon?.dateEcheance.toString().split("T")[0]
      }`,
    );

    lines.push(
      `${data.bon && data.bon.amount.toFixed(3)} ${
        parametrage && parametrage.defaultCurrency
      }`,
    );

    if (data?.bon?.code) {
      lines.push("\x1B\x61\x01"); // ESC a 1 → center

      const barcodeBuffer = addBarcode(data?.bon?.code);
      // Insérer le buffer à la fin
      lines.push(barcodeBuffer as any); // On traitera en buffer final
      lines.push("\x1B\x61\x01"); // ESC a 1 → center

      // Afficher le numéro de commande sous le code-barres
      lines.push("\x1B\x45\x01" + data?.bon?.code + "\x1B\x45\x00");
    }
    lines.push("-".repeat(32));

    if (parametrage?.message_promo) {
      // Center alignment
      lines.push("\x1B\x61\x01"); // ESC a 1 → center

      // Split the message into lines and add ESC/POS line feed
      parametrage.message_promo.split("\n").forEach((line: string) => {
        // Each line ends with \x0A (LF) for proper line feed
        lines.push(line);
      });

      // Return to left alignment
      lines.push("\x1B\x61\x00"); // ESC a 0 → left
    }
    // Add some spacing before cut
    lines.push("\x0A\x0A"); // 2 line feeds

    // Cut the paper
    lines.push("\n\n\x1D\x56\x00"); // cut

    return lines;
  }
};

export const calculTotal = (list: any[], value: string, value2?: string) => {
  if (!list || !list.length) return 0;

  return list.reduce((sum, item) => {
    let val = 0;

    if (value === "Quantiteenvoyee") {
      val = item[value] ?? item[value2!] ?? item["Quantite"] ?? 0;
    } else {
      val = item[value] ?? item[value2!] ?? 0;
    }

    return sum + val;
  }, 0);
};

export const findStockPositiveOrg = (data: any): boolean => {
  const stockData = data.stock;
  for (const orgId in stockData) {
    const hasPositive = stockData[orgId].some(
      (item: any) => (item.stock || 0) > 0,
    );

    if (hasPositive) {
      return true;
    }
  }

  return false;
};
export const findAvanceTransfer = (articleId: any, data: any[]): boolean => {
  const findArticleData = data.find((i: any) => i.article._id === articleId);

  if (!findArticleData) return false;

  const hasAvance = findArticleData.avance && Object.keys(findArticleData.avance).length > 0;
  const hasTransfer = findArticleData.transfer && Object.keys(findArticleData.transfer).length > 0;

  return !!(hasAvance || hasTransfer);
};


export const getMachineId = (id: string) => {
  let uniqueId = localStorage.getItem("idmachine");

  if (!uniqueId) {
    uniqueId = crypto.randomUUID(); // or use any random generator
    localStorage.setItem("idmachine", uniqueId);
  }

  return `${id}_${uniqueId}`;
};
